import React from 'react';
import { useTranslation } from 'react-i18next';
import { isIOS as isIOSDevice } from '../utils/deviceDetection';

const detectInstallContext = () => {
  const nav = typeof navigator !== 'undefined' ? navigator : {};
  const ua = nav.userAgent || '';
  const isIOS = isIOSDevice();
  const isSafari = /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(ua);
  const isChrome = /Chrome|CriOS/i.test(ua) && !/Edg|EdgiOS/i.test(ua);
  const isFirefox = /Firefox|FxiOS/i.test(ua);

  return { isIOS, isSafari, isChrome, isFirefox };
};

const InstallPwaInstructions = ({ compact = false }) => {
  const { t } = useTranslation();
  const { isIOS, isSafari, isChrome, isFirefox } = detectInstallContext();

  return (
    <div className={`install-instructions ${compact ? 'compact' : ''}`}>
      {isIOS ? (
        isSafari ? (
          <>
            <p><strong>{t('installPwa.ios.safari.title', 'Sur iPhone ou iPad avec Safari :')}</strong></p>
            <ol>
              <li>{t('installPwa.ios.safari.step1', 'Appuyez sur le bouton Partager')} <span aria-label="partager">↑</span> {t('installPwa.ios.safari.step1End', "en bas de l'écran")}</li>
              <li>{t('installPwa.ios.safari.step2', "Faites défiler et sélectionnez « Sur l'écran d'accueil »")}</li>
              <li>{t('installPwa.ios.safari.step3', "Validez en appuyant sur « Ajouter » en haut à droite")}</li>
            </ol>
          </>
        ) : (
          <>
            <p><strong>{t('installPwa.ios.other.title', 'Pour installer Magic Park Times sur iOS :')}</strong></p>
            <ol>
              <li>{t('installPwa.ios.other.step1', "Ouvrez d'abord cette page dans Safari")}</li>
              <li>{t('installPwa.ios.other.step2', 'Puis appuyez sur le bouton Partager')} <span aria-label="partager">↑</span> {t('installPwa.ios.other.step2End', "en bas de l'écran")}</li>
              <li>{t('installPwa.ios.other.step3', "Sélectionnez « Sur l'écran d'accueil »")}</li>
              <li>{t('installPwa.ios.other.step4', 'Validez en appuyant sur « Ajouter »')}</li>
            </ol>
          </>
        )
      ) : isChrome ? (
        <>
          <p><strong>{t('installPwa.android.chrome.title', 'Sur Android avec Chrome :')}</strong></p>
          <ol>
            <li>{t('installPwa.android.chrome.step1', "Appuyez sur l'icône ⋮ en haut à droite du navigateur")}</li>
            <li>{t('installPwa.android.chrome.step2', "Sélectionnez \"Ajouter à l'écran d'accueil\"")}</li>
            <li>{t('installPwa.android.chrome.step3', 'Validez en appuyant sur "Ajouter"')}</li>
          </ol>
        </>
      ) : isFirefox ? (
        <>
          <p><strong>{t('installPwa.android.firefox.title', 'Sur Android avec Firefox :')}</strong></p>
          <ol>
            <li>{t('installPwa.android.firefox.step1', 'Appuyez sur les trois points ⋮ en haut à droite')}</li>
            <li>{t('installPwa.android.firefox.step2', 'Sélectionnez "Installer"')}</li>
          </ol>
        </>
      ) : (
        <>
          <p><strong>{t('installPwa.android.other.title', 'Sur Android :')}</strong></p>
          <ol>
            <li>{t('installPwa.android.other.step1', 'Ouvrez le menu de votre navigateur')}</li>
            <li>{t('installPwa.android.other.step2', "Recherchez l'option \"Ajouter à l'écran d'accueil\" ou \"Installer\"")}</li>
            <li>{t('installPwa.android.other.step3', "Suivez les instructions à l'écran")}</li>
          </ol>
        </>
      )}
    </div>
  );
};

export default InstallPwaInstructions;
